import Icon from '@ant-design/icons';
import {LAYOUT} from '@dofleini/auth-layout';
import {useKeycloak} from '@react-keycloak/web';
import {Button, Divider} from 'antd';
import PropTypes from 'prop-types';
import React, {memo} from 'react';
import {useTranslation} from 'react-i18next';
import styled from 'styled-components';

import {ReactComponent as Datys} from '@/assets/images/datys.svg';
import AuthLayoutRight from '@/components/AuthLayout/AuthLayoutRight';

const AuthContainer = styled.div`
    background-color: white !important;
    box-shadow: 0 3px 6px -4px rgb(0 0 0 / 12%), 0 6px 16px 0 rgb(0 0 0 / 8%), 0 9px 28px 8px rgb(0 0 0 / 5%);
    border-radius: 6px 6px;

    .auth-right-side {
        border-top-left-radius: 6px;
        border-bottom-left-radius: 6px;
        background-color: #333;
    }
`;
const FormContainer = styled.div`
    padding: 12px 20px 20px;
    min-height: 280px;
    @media (min-width: 575px) {
        padding: 15px 25px 25px;
        width: 385px;
    }
`;

const isDatysActive = JSON.parse(process.env.REACT_APP_DATYS_ACTIVE || false);

const AuthLayout = ({children, setVisible}) => {
  const {t} = useTranslation('common');
  const {keycloak} = useKeycloak();
  
  return (
    <AuthContainer>
      <div className={'flex'}>
        <AuthLayoutRight setVisible={setVisible}/>
        <FormContainer>
          {children}
          
          {isDatysActive && <>
            <Divider className="my-1">
              <span className="font-light">
                {t('orUseThisSocial')}
              </span>
            </Divider>
            <div
              className={'grid grid-cols-1 gap-4 mt-4 truncate'}>
              <Button
                size="large"
                className="w-full truncate rounded-full"
                icon={<Icon component={Datys}/>}
                onClick={() => keycloak.login({
                  scope: 'openid profile email phone photo certification',
                })}
              >
                {t('idpDatys')}
              </Button>
            </div>
          </>}
        </FormContainer>
      </div>
    </AuthContainer>
  );
};

AuthLayout.propTypes = {
  children: PropTypes.any,
  image: PropTypes.any,
  background: PropTypes.string,
  formBackground: PropTypes.string,
  layout: PropTypes.string,
  setVisible: PropTypes.func,
};

export default memo(AuthLayout);

AuthLayout.defaultProps = {
  formBackground: '#ffffff',
  layout: LAYOUT.CENTER_BOX,
};
